const enGB = {
  navigation: {
    mydevice: "Mi dispositivo",
    mymobile: "Mon mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "Fotos",
      favorites: "Favoritas",
      collections: "Colecciones",
      events: "Eventos",
      latestuploads: "Últimas cargas"
    },
    empty(source) {
      return "No tienes fotos en " + source
    }
  },
  mymobile: {
    title: "Récupérez les photos de votre mobile en un instant!",
    qrcode: {
      title: "Scannez le QR code",
      subtitle: "(Aucune application à installer)"
    },
    instruction: {
      title: "C'est parti!",
      step_1: "Ouvrez votre application Appareil Photo",
      step_2: "Scannez le QR code",
      step_3: "Suivez les instructions sur votre téléphone"
    }
  },
  layout: {
    flex: "Flexible",
    square: "Cuadrado"
  },
  calender: {
    allmonths: "Todos los meses",
    allyears: "Todos los años",
    months: {
      january: "Enero",
      february: "Febrero",
      march: "Marzo",
      april: "Abril",
      may: "Mayo",
      june: "Junio",
      july: "Julio",
      august: "Agosto",
      september: "Septiembre",
      october: "Octubre",
      november: "Noviembre",
      december: "Diciembre"
    }
  },
  generic: {
    sortBy: "Ordenar por",
    selected: "Seleccionadas",
    done: "Añadir fotos",
    back: "Volver",
    images: "Fotos",
    selection: "Selección",
    date: "Fecha",
    name: "Nombre",
    az: "Nombre de archivo A-Z",
    za: "Nombre de archivo Z-A",
    newestfirst: "Fecha de captura de más nueva a más antigua",
    oldestfirst: "Fecha de captura de más antigua a más nueva",
    photos: "Fotos",
    all: "Todo",
    yes: "Sí",
    no: "No",
    nodate: "Sin cita"
  },
  rangeText: {
    minMax(min, max) {
      return "Debes seleccionar entre " + min + " y " + max + " fotos"
    },
    min(min) {
      return "Necesitas al menos " + min + " fotos para crear tu álbum."
    },
    max(max) {
      return "Puedes seleccionar un máximo de " + max + " fotos"
    }
  },
  addMorePhotos: "Añadir más fotos",
  upload: {
    browseButton: "Añadir fotos",
    uploadlimit(maxSize) {
      return "Las fotos tienen que ser inferiores a " + maxSize + " en el tamaño del archivo"
    },
    dragImage: "o arrastrar y soltar fotos aquí.",
    errors: {
      GENERIC_ERROR: "Se ha producido un problema. Vuelve a intentarlo más tarde o ponte en contacto con el servicio de atención al cliente.",
      EMPTY_FILE: "Referencia de imagen perdida, vuelve a añadir la imagen",
      MAX_FILE_SIZE: "El archivo debe ser menor que {0} MB",
      UNSUPPORTED_FILE_TYPE: "Formato de archivo no compatible",
      MAX_IMAGE_RESOLUTION: "El archivo debe ser menor que {0} píxeles",
      INVALID_IMAGE: "El archivo está roto"
    },
    errorSummary(number) {
      return "No se pudo cargar " + number + " archivos"
    },
    errorDialog: {
      headline: "¡Vaya!",
      ingress: "No se pudo cargar los siguientes archivos:",
      filenameColumn: "Archivo",
      reasonColumn: "Motivo"
    },
    uploaded: "Cargado",
    estimating: "Calculando el tiempo",
    estimatedleft: "Tiempo restante estimado",
    ok: "OK",
    cancel: "Cancelar",
    details: "Detalles"
  }
}

export default enGB
